/* Combobox remoto de compañias */
import { useLazyQuery } from "@apollo/client";
import { SelectProps } from "antd";
import { COMPANIES } from "./ComboboxGQL";
import RemoteComboBox from "../../../shared/RemoteComboBox";

interface CompaniesComboBoxProps extends SelectProps<string> {
    pageSize?: number;
    where?: Record<string, any>;
    onSelectFull?: (item: { id: string; name: string; product: string[] }) => void;
}

const CompaniesComboBox: React.FC<CompaniesComboBoxProps> = ({
    pageSize = 7,
    where,
    onSelectFull,
    ...props
}) => {
    const DEFAULT_VARIABLES = where ? { where } : {};

    const [getData, { data, loading, error }] = useLazyQuery(COMPANIES, {
        fetchPolicy: "no-cache",
    });

    const fetchData = (options: any) => {
        const { search, ...rest } = options.variables ?? {};
        const mergedWhere = {
            deleted_at: { equals: null },
            is_active: { equals: true },
            ...(where ?? {}),
            ...(search ? { name: { contains: search } } : {}),
        };
        getData({ variables: { ...rest, where: mergedWhere } });
    };

    const handleChange = (value: any, option: any) => {
        if (onSelectFull && data?.companies) {
            const id = typeof value === 'object' ? value?.value : value
            const found = data.companies.find((c: any) => c.id === id)
            if (found) onSelectFull(found)
            if (!value) onSelectFull({ id: '', name: '', product: [] })
        }
        props.onChange?.(value, option)
    }

    return (
        <RemoteComboBox
            {...props}
            onChange={handleChange}
            showSearch
            optionIdKey={"id"}
            optionValueKey={"name"}
            pageSize={pageSize}
            defaultVariables={DEFAULT_VARIABLES}
            fetchData={fetchData}
            data={data}
            optionFilterProp="children"
            dataKey={"companies"}
            loading={loading}
            error={error}
            addDropRender
        />
    );
};

export default CompaniesComboBox;
